// Per-deployment configuration, read at page load rather than baked into the
// bundle. docker-entrypoint.sh writes /env-config.js from the container app's
// XTRACT_* env vars, and index.html loads it before the app bundle. This is
// what lets one frontend image be promoted unchanged from dev to uat, prod
// and every client environment: only the container env differs.
//
// Each value falls back to its build-time VITE_* counterpart so local
// `npm run dev` and older deployments that never set the runtime vars keep
// working exactly as before.
const runtime = typeof window !== 'undefined' ? (window.__XTRACT_CONFIG__ || {}) : {}

function runtimeString(key) {
  const value = runtime[key]
  return typeof value === 'string' && value.trim() !== '' ? value.trim() : undefined
}

function runtimeFlag(key, buildValue) {
  const value = runtime[key]
  if (value === true || value === 'true') return true
  if (value === false || value === 'false') return false
  return buildValue === 'true'
}

const runtimeShowDevLogs = runtime.showDevLogs

export const SHOW_DEV_LOGS = runtimeShowDevLogs !== undefined
  ? runtimeShowDevLogs === true || runtimeShowDevLogs === 'true'
  : import.meta.env.VITE_SHOW_DEV_LOGS === 'true'

const runtimeClientId = runtimeString('azureClientId')

export const AZURE_CLIENT_ID = runtimeClientId || import.meta.env.VITE_AZURE_CLIENT_ID || ''

// A runtime client ID must never be paired with a build-time scope: the image
// may have been built for a different app registration (Synapx vs a client
// tenant), and a mismatched scope fails sign-in. So derive the scope from the
// runtime client ID unless a runtime scope is given explicitly.
export const AZURE_API_SCOPE = runtimeClientId
  ? (runtimeString('azureApiScope') || `api://${runtimeClientId}/access_as_user`)
  : (import.meta.env.VITE_AZURE_API_SCOPE || (AZURE_CLIENT_ID ? `api://${AZURE_CLIENT_ID}/access_as_user` : ''))

export const DEFAULT_BRANDING_ENV = {
  appName: runtimeString('defaultAppName') || import.meta.env.VITE_DEFAULT_APP_NAME,
  subtitle: runtimeString('defaultSubtitle') || import.meta.env.VITE_DEFAULT_SUBTITLE,
  primaryColor: runtimeString('defaultPrimaryColor') || import.meta.env.VITE_DEFAULT_PRIMARY_COLOR,
  accentColor: runtimeString('defaultAccentColor') || import.meta.env.VITE_DEFAULT_ACCENT_COLOR,
  logoFile: runtimeString('defaultLogoFile') || import.meta.env.VITE_DEFAULT_LOGO_FILE,
  faviconFile: runtimeString('defaultFaviconFile') || import.meta.env.VITE_DEFAULT_FAVICON_FILE,
}

export const READER_ROLE_FLAG = runtimeFlag('enableReaderRole', import.meta.env.VITE_ENABLE_READER_ROLE)

export const HIDE_TEMPLATE_SELECTOR_FLAG = runtimeFlag('hideTemplateSelector', import.meta.env.VITE_HIDE_TEMPLATE_SELECTOR)

// OpCo workspaces (backend ENABLE_OPCO). Off => no /o/<code> basename and no
// X-OpCo header: the app behaves exactly as before.
export const OPCO_FLAG = runtimeFlag('enableOpco', import.meta.env.VITE_ENABLE_OPCO)

// Learning section (#735). Every install reads its how-to videos from one hub
// deployment (Synapx prod), so a new video shows up everywhere on refresh.
// XTRACT_LEARNING_HUB_URL overrides the hub; 'self' (or this app's own
// origin) means the hub is this deployment, i.e. same-origin ('').
export const DEFAULT_LEARNING_HUB_URL = 'https://xtract.synapx.delivery'

export function resolveLearningHubUrl(value, currentOrigin) {
  const raw = typeof value === 'string' ? value.trim() : ''
  if (raw.toLowerCase() === 'self') return ''
  const hub = (raw || DEFAULT_LEARNING_HUB_URL).replace(/\/+$/, '')
  if (currentOrigin && hub.toLowerCase() === String(currentOrigin).toLowerCase()) return ''
  return hub
}

export const LEARNING_HUB_URL = resolveLearningHubUrl(
  runtimeString('learningHubUrl') || import.meta.env.VITE_LEARNING_HUB_URL,
  typeof window !== 'undefined' ? window.location?.origin : '',
)
